import { Component, Input, OnInit } from '@angular/core';
import { DataColeccionista } from 'app/models/coleccionitas.model';
import { StatusStickerComponent } from "../../../../GlobalComponents/status sticker.component";

@Component({
    selector: 'informacion-personal-coleccionista',
    templateUrl: 'informacion-personal.component.html',
    imports: [StatusStickerComponent]
})

export class InformacionPersonalColeccionistaComponent implements OnInit {
    @Input() coleccionista: DataColeccionista
    constructor() { }

    ngOnInit() { }
}